import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RouteData } from './core/route-data';
import { Rights } from './models/enums/rights';
import { MemoryService } from './services/memory.service';

@Injectable({
    providedIn: 'root',
})
export class UserGrantedGuard {
    /**
     * Constructeur.
     * @param router : Instance du router.
     */
    constructor(
        private router: Router,
        public memoryService: MemoryService
    ) {}

    /**
     * Listes des rôles permettant d'acceder à la route.
     */
    expectedRights: Rights[] = [];

    /**
     * Indique si la route peut-être activée.
     * @param next : Instance de la route.
     * @param state : Etat du routeur.
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        console.log('UserGrantedGuard#canActivate called');

        // this will be passed from the route config
        // on the data property
        this.expectedRights = (next.data as RouteData).expectedRights as Rights[];

        var connectedUser = this.memoryService.getConnectedUser();

        if (connectedUser) {
            if (this.expectedRights.length == 0) {
                // Aucun droit attendu par la route
                return true;
            }

            if (this.expectedRights.filter((expectedRight) => connectedUser.rights.findIndex((userRight) => userRight === expectedRight) !== -1).length === 0) {
                console.log("L'utilisateur n'est pas authorisé");
                this.router.navigate(['']);
                return false;
            }

            console.log("L'utilisateur est autorisé");
            return true;
        } else {
            console.log("L'utilisateur n'est pas authentifié.");
            return false;
        }
    }
}
